<button
    class="btn option-btn btn-link dropdown-toggle"
    type="button"
    id="context-menu-{{ itemIndex }}"
    (click)="toggleContextMenu($event)"
    (contextmenu)="toggleContextMenu($event)"
>
    <fa-icon class="ms-2"
             [icon]="faPaperclip"
             placeholder="Right"></fa-icon>
</button>
